import { getLeagueLandingPath, getLeagueTeamPath } from './league-public-paths';

const BASE_URL = 'https://www.elitesportstours.com';

/**
 * SEO-aware navigation links
 * Use these for all league/team links to ensure canonical URLs are used.
 * Falls back to /events/:league for leagues without SEO vanity URLs.
 */

export const seoLinks = {
  /** League landing page (e.g., /mlb-travel-packages or /events/nba) */
  leaguePage: (leagueSlug: string) => getLeagueLandingPath(leagueSlug),

  /** Team page (e.g., /mlb-travel-packages/yankees or /events/nba/lakers) */
  teamPage: (leagueSlug: string, teamSlug: string) =>
    getLeagueTeamPath(leagueSlug, teamSlug),

  /** Full absolute URL for schema markup (required by schema.org) */
  absoluteLeagueUrl: (leagueSlug: string) =>
    `${BASE_URL}${getLeagueLandingPath(leagueSlug)}`,

  /** Full absolute URL for schema markup (required by schema.org) */
  absoluteTeamUrl: (leagueSlug: string, teamSlug: string) =>
    `${BASE_URL}${getLeagueTeamPath(leagueSlug, teamSlug)}`,

  /** Legacy helper for concerts and non-SEO categories */
  eventsPage: (path: string) => `/events${path}`,
};
